import React from 'react';
import {NavLink} from 'react-router-dom';
import styles from './MyLink.css';
import { withStyles, Typography, Button } from '@material-ui/core';

function MyLink(props){
    const {classes} = props;
    return (
        <NavLink {...props} className={classes.appbarLink} variant='inherit'>
            <Button color='secondary'>
                <Typography variant='body1'>{props.children}</Typography>
            </Button>
        </NavLink>
    );
}

export default withStyles(styles, {withTheme: true})(MyLink);